import { Cognito } from 'utils/cognito';

export const normalizeString = (str: string = '') => str.trim().toLowerCase();

export const getCurrentCognitoUser = () => {
  const userPool = Cognito.userPool();
  return userPool.getCurrentUser();
};
